var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "copy-to-layout-modal",
        title: "Copy to Layout",
        centered: "",
        "ok-title": "Copy",
        "ok-disabled": !_vm.selectedLayout && _vm.createNewLayout === "false",
      },
      on: { ok: _vm.handleSave, cancel: _vm.closeModal },
    },
    [
      _c(
        "b-form-group",
        { staticClass: "mb-3", attrs: { label: "Layout Options" } },
        [
          _c(
            "b-form-radio-group",
            {
              attrs: { name: "layout-option" },
              model: {
                value: _vm.createNewLayout,
                callback: function ($$v) {
                  _vm.createNewLayout = $$v
                },
                expression: "createNewLayout",
              },
            },
            [
              _c("b-form-radio", { attrs: { value: "false" } }, [
                _vm._v("\n        Use existing layout\n      "),
              ]),
              _vm._v(" "),
              _c("b-form-radio", { attrs: { value: "true" } }, [
                _vm._v("\n        Create new layout\n      "),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.createNewLayout === "true"
        ? _c(
            "b-form-group",
            { staticClass: "mb-3", attrs: { label: "New Layout Name" } },
            [
              _c("b-form-input", {
                attrs: { placeholder: "Enter new layout name", required: "" },
                model: {
                  value: _vm.newLayoutName,
                  callback: function ($$v) {
                    _vm.newLayoutName = $$v
                  },
                  expression: "newLayoutName",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.createNewLayout === "false"
        ? _c("Multiselect", {
            staticClass: "mb-3",
            attrs: {
              options: _vm.layouts,
              loading: _vm.isLoading,
              searchable: "",
              multiple: "",
              "custom-label": _vm.customLabel,
              "track-by": "id",
              placeholder: "Add to layout",
            },
            on: {
              "search-change": _vm.searchCustomerLayouts,
              select: (option) => (_vm.selectedLayout = [option]),
            },
            scopedSlots: _vm._u(
              [
                _vm.layouts.length < _vm.layoutsTotalCount
                  ? {
                      key: "afterList",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            { staticClass: "load-more-btn" },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    disabled: _vm.isLoading,
                                    variant: "outline-primary",
                                  },
                                  on: { click: _vm.getLayouts },
                                },
                                [_vm._v("\n          Load More\n        ")]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
            model: {
              value: _vm.selectedLayout,
              callback: function ($$v) {
                _vm.selectedLayout = $$v
              },
              expression: "selectedLayout",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-checkbox",
        {
          staticClass: "mt-3",
          model: {
            value: _vm.moveTemplate,
            callback: function ($$v) {
              _vm.moveTemplate = $$v
            },
            expression: "moveTemplate",
          },
        },
        [_vm._v("\n    Move template\n  ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }